/**
 * Campañas de saldo. El saldo de campaña (walletPromoBalance) no es retirable: se gasta en
 * las comisiones de los viajes y no genera bonos de referido.
 */

const num = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};

export const WALLET_CAMPAIGN_AUDIENCES = {
  new_driver: 'Conductores nuevos',
};

export const getWalletPromoBalance = (user) => Math.min(Math.max(0, num(user && user.walletPromoBalance)), Math.max(0, num(user && user.walletBalance)));

export const getWithdrawableBalance = (user) => Math.max(0, num(user && user.walletBalance) - Math.max(0, num(user && user.walletPromoBalance)));

/** 'active' | 'scheduled' | 'paused' | 'ended' | 'exhausted' */
export const walletCampaignStatus = (campaign, now = Date.now()) => {
  const endAt = num(campaign.endAt);
  const max = num(campaign.maxGrants);
  if (endAt > 0 && now > endAt) return 'ended';
  if (max > 0 && num(campaign.grantedCount) >= max) return 'exhausted';
  if (!campaign.active) return 'paused';
  if (num(campaign.startAt) > now) return 'scheduled';
  return 'active';
};
